import resume from '../assets/pdf/resume.pdf'
import front_image from '../assets/png/Ravjodh_Medium.png'

export const headerData = {
    name: 'Ravjodh Heer',
    title: "Software Engineer. FullStack Developer. Cloud Specialist.",
    desciption:"Self-taught programmer with a passion for creativity and development. AWS Engineer and UC Santa Cruz graduate. Feel free to look around and learn more about me on this interactive web portfolio!",
    image: front_image,
    resumePdf: resume
}
